// extracted by mini-css-extract-plugin
module.exports = {"wrap":"a10a3f92e9--wrap--GxrmQ","tabs":"a10a3f92e9--tabs--oFZVe","wrap-left-blur":"a10a3f92e9--wrap-left-blur--ogvsl","wrap-right-blur":"a10a3f92e9--wrap-right-blur--Ja_OL"};